import get from 'lodash/object/get'
import { getSitesState } from 'sites/selectors'

export const getManageState = state =>
  get(getSitesState(state), 'domains.manage')
